
import Vue, { PropType } from 'vue'

import { IEntityReviewFull } from 'types/DTO/reviews'

export default Vue.extend({
  name: 'RPHReviewCard',
  components: {
    RPHStarRating: () => import('~/components/v2/atoms/RPHStarRating/index.vue'),
    Heading: () => import('~/components/atoms/Heading.vue'),
    RPHButton: () => import('rph/atoms/RPHButton/index.vue'),
  },
  props: {
    data: {
      type: Object as PropType<any>,
      default: () => {},
    },
    isRate: {
      type: Boolean,
      default: true,
    },
    /* Будет ли кнопка Ответить */
    isFeedback: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    createdAt() {
      return this.$services.common.numberFormat.formatDateIncline(this.$props.data.created_at)
    },
    getAuthorOfComment(): string {
      /* Получаем имя кому был написан ответ */
      const name = this.data.content.split(',')[0]
      const reviews = this.$store.getters['rph-reviews/reviews']

      for (const user of reviews) {
        if (user.user.name === name) {
          return name
        }
      }

      return ''
    },
  },
  methods: {
    setName(name: string): void {
      this.$emit('set-name', name)
    },
  },
})
